import { useSelector, useDispatch } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { useEffect } from "react";

import { getUserIsLoggedInSelector } from "../redux/selectors/AuthSelectors";
import { allRoutes } from "../routes/routes";
import { isSessionValid } from "../utils/sessionUtils"; 
import { logoutAction } from "../redux/actions/AuthActions";

const ProtectedRoutes = ({ type = "after_login" }) => {
  const dispatch = useDispatch();
  const userIsLoggedIn = useSelector(getUserIsLoggedInSelector);

  useEffect(() => {
    if (!isSessionValid()) {
      dispatch(logoutAction());
    }
  }, [dispatch]);

  return type === "after_login" ? (
    userIsLoggedIn ? (
      <Outlet />
    ) : (
      <Navigate to={allRoutes.login} />
    )
  ) : userIsLoggedIn ? (
    <Navigate to={allRoutes.dashboard} />
  ) : (
    <Outlet />
  );
};

export default ProtectedRoutes;
